module.exports = __webpack_public_path__ + "img/42.a95052b7.png";